export const POST_OP_GUIDE = [
  {
    title: "Проверявай раната!",
    description: "Проверявай всеки ден раната от кастрация за: зачервяване, подуване или изтечения.",
    image: "/img/watch.png",
    icon: "🔍"
  },
  {
    title: "Отдели животните!",
    description: "Отдели женските животни от некастрираните мъжки! Прясно кастриран котарак все още може да заплоди женска (до няколко седмици след операцията), а и физическата игра между две животни може да разкъса раната.",
    image: "/img/separate.png",
    icon: "🏠"
  },
  {
    title: "Без близане!",
    description: "Близането на раната може да доведе до възпаление. Ако котката е упорита, задължително използвайте предпазна яка или дрешка.",
    image: "/img/no-licking.png",
    icon: "🚫👅"
  },
  {
    title: "Пази я суха!",
    description: "Водата възпалява раната и спомага нейното отваряне. Без къпане поне 10 дни.",
    image: "/img/keep-it-dry.png",
    icon: "💧❌"
  },
  {
    title: "При котараците няма шевове!",
    description: "Нормално е след кастрация на котараците да им се подуе скротума и да има капкови изтечения от мястото.",
    image: "/img/males.png",
    icon: "🐱",
    onlyFor: "male"
  },
  {
    title: "Ограничи движението!",
    description: "Почивката помага на тъканите да зараснат. Ограничи тичането и особено скачането на високо, за да не се разтяга коремната стена.",
    image: "/img/rest.png",
    icon: "💤"
  },
  {
    title: "Храни с проста храна!",
    description: "Не давай на твоето животно остатъци от масата, мляко или тежки храни в деня след операцията.",
    image: "/img/food.png",
    icon: "🥘"
  },
  {
    title: "Без човешки лекарства!",
    description: "Повечето лекарства за хора са фатални за животните! На Вашето животно вече са сложени нужните лекарства с продължително действие.",
    image: "/img/pills.png",
    icon: "💊🚫"
  }
];